import { render } from "./Overlay.vue?vue&type=template&id=7d9ece50"
const script = {}

import "./Overlay.vue?vue&type=style&index=0&id=7d9ece50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Overlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d9ece50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d9ece50', __exports__)) {
    api.reload('7d9ece50', __exports__)
  }
  
  module.hot.accept("./Overlay.vue?vue&type=template&id=7d9ece50", () => {
    api.rerender('7d9ece50', render)
  })

}


export default __exports__